import { render, staticRenderFns } from "./MemberBenefit.vue?vue&type=template&id=269e726a&scoped=true"
import script from "./MemberBenefit.vue?vue&type=script&lang=js"
export * from "./MemberBenefit.vue?vue&type=script&lang=js"
import style0 from "./MemberBenefit.vue?vue&type=style&index=0&id=269e726a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269e726a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269e726a')) {
      api.createRecord('269e726a', component.options)
    } else {
      api.reload('269e726a', component.options)
    }
    module.hot.accept("./MemberBenefit.vue?vue&type=template&id=269e726a&scoped=true", function () {
      api.rerender('269e726a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productInfo/MemberBenefit.vue"
export default component.exports